/**
 * GLCHN Theme JavaScript
 * Minimal JS for essential interactions
 */

(function() {
  'use strict';

  // Mobile menu toggle
  function initMobileMenu() {
    const menuToggle = document.querySelector('.header__menu-toggle');
    const mobileMenu = document.querySelector('[data-mobile-menu]');
    const closeButton = document.querySelector('[data-mobile-menu-close]');
    const sectionHeader = document.querySelector('.section-header');

    if (!menuToggle || !mobileMenu) return;

    // Initialize focus trap
    let focusTrap = null;
    if (window.FocusTrap) {
      focusTrap = new window.FocusTrap(mobileMenu, {
        onEscape: closeMenu
      });
    }

    function openMenu() {
      menuToggle.setAttribute('aria-expanded', 'true');
      mobileMenu.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (sectionHeader) sectionHeader.classList.add('menu-open');

      // Activate focus trap after animation
      if (focusTrap) {
        setTimeout(() => focusTrap.activate(), 300);
      }
    }

    function closeMenu() {
      menuToggle.setAttribute('aria-expanded', 'false');
      mobileMenu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (sectionHeader) sectionHeader.classList.remove('menu-open');

      // Deactivate focus trap
      if (focusTrap) {
        focusTrap.deactivate();
      }
    }

    menuToggle.addEventListener('click', () => {
      const isExpanded = menuToggle.getAttribute('aria-expanded') === 'true';
      if (isExpanded) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    if (closeButton) {
      closeButton.addEventListener('click', closeMenu);
    }

    // Close menu on escape key (fallback if focus trap not loaded)
    if (!focusTrap) {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && mobileMenu.getAttribute('aria-hidden') === 'false') {
          closeMenu();
        }
      });
    }
  }

  // Dropdown toggles
  function initDropdowns() {
    const dropdownToggles = document.querySelectorAll('.header__dropdown-toggle, .mobile-menu__dropdown-toggle');

    dropdownToggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', !isExpanded);
      });
    });
  }

  // Quantity selectors
  function initQuantitySelectors() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-action="decrease"], [data-action="increase"]');
      if (!btn) return;

      const action = btn.dataset.action;
      const container = btn.closest('.product-page__quantity-selector, .cart-page__quantity-selector');
      const input = container?.querySelector('input[type="number"]');

      if (!input) return;

      const currentValue = parseInt(input.value, 10) || 1;
      const min = parseInt(input.min, 10) || 0;
      const max = parseInt(input.max, 10) || Infinity;

      if (action === 'decrease' && currentValue > min) {
        input.value = currentValue - 1;
      } else if (action === 'increase' && currentValue < max) {
        input.value = currentValue + 1;
      }

      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // Product variant selector
  function initVariantSelector() {
    const optionSelects = document.querySelectorAll('.product-page__option-select');
    const variantSelect = document.querySelector('.product-page__variant-select');

    if (!optionSelects.length || !variantSelect) return;

    optionSelects.forEach(select => {
      select.addEventListener('change', () => {
        const selectedOptions = Array.from(optionSelects).map(s => s.value);
        const variantOptions = Array.from(variantSelect.options);

        const matchingVariant = variantOptions.find(option => {
          const variantTitle = option.textContent.split(' - ')[0].trim();
          return variantTitle === selectedOptions.join(' / ');
        });

        if (matchingVariant) {
          variantSelect.value = matchingVariant.value;
        }
      });
    });
  }

  // Product image gallery
  function initProductGallery() {
    const thumbnails = document.querySelectorAll('.product-page__thumbnail');
    const mainImage = document.querySelector('.product-page__main-image img');

    if (!thumbnails.length || !mainImage) return;

    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbnails.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');

        const newSrc = thumb.querySelector('img')?.src.replace(/width=\d+/, 'width=1000');
        if (newSrc) {
          mainImage.src = newSrc;
        }
      });
    });
  }

  // Collection sort
  function initCollectionSort() {
    const sortSelect = document.querySelector('[data-sort-by]');
    if (!sortSelect) return;

    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  // Language switcher
  function initLanguageSwitcher() {
    document.querySelectorAll('.language-link[data-language-code]').forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const code = link.dataset.languageCode;
        const form = link.closest('.language-switcher').querySelector('form');
        if (!form) return;
        form.querySelector('input[name="locale_code"]').value = code;
        form.submit();
      });
    });
  }

  // Initialize all modules
  function init() {
    initMobileMenu();
    initDropdowns();
    initQuantitySelectors();
    initVariantSelector();
    initProductGallery();
    initCollectionSort();
    initLanguageSwitcher();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
